import { attachErrorCodeDomain } from "./i18n-error-code-common";
import { errorCodeDomain as zhErrorCodes } from "./i18n/features/zh/error-code-exam";
import { errorCodeDomain as enErrorCodes } from "./i18n/features/en/error-code-exam";
import { errorCodeDomain as jaErrorCodes } from "./i18n/features/ja/error-code-exam";

import { common as zhCommon } from "./i18n/common";
import { commonCatalog as enCommon } from "./i18n/features/en/common";
import { examAdminCatalog as enExamAdmin } from "./i18n/features/en/exam-admin";
import { loginCenterEn } from "./i18n/features/en/login-center";
import { platformSharedLogin as enSharedLogin } from "./i18n/features/en/platform-shared-login";
import { commonCatalog as jaCommon } from "./i18n/features/ja/common";
import { examAdminCatalog as jaExamAdmin } from "./i18n/features/ja/exam-admin";
import { loginCenterJa } from "./i18n/features/ja/login-center";
import { platformSharedLogin as jaSharedLogin } from "./i18n/features/ja/platform-shared-login";
import { examAdminCatalog as zhExamAdmin } from "./i18n/features/zh/exam-admin";
import { loginCenterZh } from "./i18n/features/zh/login-center";
import { platformSharedLogin as zhSharedLogin } from "./i18n/features/zh/platform-shared-login";
import {
  APP_LOCALE_LABELS,
  APP_LOCALES,
  DEFAULT_LOCALE,
  getLocale as sharedGetLocale,
  normalizeLocale,
  setLocale as sharedSetLocale,
  subscribeLocaleChange as sharedSubscribeLocaleChange,
} from "./i18n/locale-state";
import { createI18nRuntime } from "./i18n/runtime";

// Error codes are app-owned: attach exactly the domain this transport renders.
attachErrorCodeDomain("exam", {
  "zh-CN": zhErrorCodes,
  en: enErrorCodes,
  ja: jaErrorCodes,
});

export type { AppLocale } from "./i18n/locale-state";
export { APP_LOCALE_LABELS, APP_LOCALES, DEFAULT_LOCALE, normalizeLocale } from "./i18n/locale-state";

const localeCatalogs = {
  "zh-CN": {
    common: zhCommon,
    admin: zhExamAdmin,
    platform: { sharedLogin: zhSharedLogin, admin: { login: loginCenterZh } },
  },
  en: {
    common: enCommon,
    admin: enExamAdmin,
    platform: { sharedLogin: enSharedLogin, admin: { login: loginCenterEn } },
  },
  ja: {
    common: jaCommon,
    admin: jaExamAdmin,
    platform: { sharedLogin: jaSharedLogin, admin: { login: loginCenterJa } },
  },
} as const;

export const zhCN = localeCatalogs["zh-CN"];
export type Messages = typeof zhCN;

export const {
  messageCatalogs,
  setLocale,
  getLocale,
  subscribeLocaleChange,
  createMessageProxy,
  hasMessage,
  t,
  formatMessage,
  formatEnumPath,
  formatEnumLabel,
  formatBooleanLabel,
  formatLocalizedList,
  formatActionObjectLabel,
  formatActionObjectMessage,
  formatActionObjectIntlLabel,
} = createI18nRuntime({
  defaultLocale: DEFAULT_LOCALE,
  localeCatalogs,
  normalizeLocale,
  localeState: {
    getLocale: sharedGetLocale,
    setLocale: sharedSetLocale,
    subscribeLocaleChange: sharedSubscribeLocaleChange,
  },
});

export type { DeepPartialMessageTree, FormatMessageLike, MessageDescriptor, MessageParams, MessageTree } from "./i18n/runtime";
